import axios from "axios";
import UserService from "./UserService";
import API_BASE_URL from "../config/api";

const HttpMethods = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  PATCH: 'PATCH'
};

const _axios = axios.create({ baseURL: API_BASE_URL });
const _axios_registro = axios.create({ baseURL: API_BASE_URL });

const configure = () => {
  _axios.interceptors.request.use((config) => {
    if (UserService.isLoggedIn()) {
      const cb = () => {
        config.headers.Authorization = `Bearer ${UserService.getToken()}`;
        return Promise.resolve(config);
      };
      return UserService.updateToken(cb);
    }
    return Promise.resolve(config);
  });
};

const getAxiosClient = () => _axios;
const getAxiosClientRegistro = () => _axios_registro;

const HttpService = {
  HttpMethods,
  configure,
  getAxiosClient,
  getAxiosClientRegistro,
};

export default HttpService;
